<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Município</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdmunicipio) }}</div>
            </div>
            <div class="form-item">
                <label class="label-caption">Nome</label>
                <input type="text" v-model="objEdicao.nmmunicipio" required maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption">IBGE</label>
                <input type="text" class="input-right" v-model="edIbge" v-number maxlength="9" />
            </div>
            <div class="form-item-char05">
                <label class="label-caption">UF</label>
                <input type="text" v-model="objEdicao.uf" maxlength="2" v-uppercase />
            </div>
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarMunicipio } from '@/models/municipio';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const edIbge = ref(null);
const isLoading = ref(false);
const msg = ref(null);
const objEdicao = ref(criarMunicipio());

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('municipio', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
        objEdicao.value.idusuario       = globalStore.idusuario;
        edIbge.value                    = Funcoes.formatInteger(objEdicao.value.idibge);
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    if (!objEdicao.value.nmmunicipio || objEdicao.value.nmmunicipio.trim() === '') {msg.value='Informe o nome do município'; return;}
    try {
        isLoading.value         = true;
        msg.value               = null;
        objEdicao.value.idibge  = Funcoes.integerFromString(edIbge.value);
        const response      = await Api.genericPut('/cad/municipio', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>